var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const BASE_ROUTER = 'api/integrations';
const BASE_ROUTER_MP = 'api/mercadopago';
const BASE_ROUTER_MP_ATTEMPTS = 'api/payments/mp/attempts';
export const getMPConnectionStatus = function () {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${BASE_ROUTER}/mp/connection`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const getDiscoverMPTerminals = function (_a) {
    return __awaiter(this, arguments, void 0, function* ({ mp_store_id }) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${BASE_ROUTER}/mp/terminals/discover?mp_store_id=${mp_store_id}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const getStoredMPTerminals = function (_a) {
    return __awaiter(this, arguments, void 0, function* ({ storeId }) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${BASE_ROUTER}/mp/terminals?storeId=${storeId}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const getMPUsersStores = function (_a) {
    return __awaiter(this, arguments, void 0, function* ({ user_id }) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${BASE_ROUTER_MP}/users/stores?user_id=${user_id}`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
export const getMPAttemptStatus = function (_a) {
    return __awaiter(this, arguments, void 0, function* ({ attemptId }) {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.get(`${BASE_ROUTER_MP_ATTEMPTS}/${attemptId}/status`, config);
        }
        catch (error) {
            throw error;
        }
    });
};
